import johnPic from "@/public/images/artists/john.png";
import { Artist } from "@/types/types";

export const john = {
  id: "169",
  name: "John",
  image: johnPic,
  description: `John's voice is ethereal and emotive, marked by a delicate falsetto and introspective tone. His singing often carries a subtle vibrato and soft resonance, adding an understated depth to his performance.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fjohn-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: [
        "Indie",
        "Folk",
        "Alternative",
        "Ballads",
        "Ethereal",
        "Falsetto",
      ],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Very high",
      },
      specific: {
        low: 48,
        high: 74,
      },
      sweetSpot: 65,
    },
  },
} as const satisfies Artist;
